import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import AcompanhamentoCargaCIFCompleteParameters from "../classes/AcompanhamentoCargaCIFCompleteParameters";
import AcompanhamentoEntregaCIF from "../classes/AcompanhamentoEntregaCIF";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  {
    method: "POST",
    rota: "AcompanhamentoCargaCIF/RecuperarPorFiltro",
  }
];

const apiServico: string = "PEDIDOS";

export default class AcompanhamentoEntregaCIFDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  /*
  async getAll(param : AcompanhamentoCargaCIFCompleteParameters ): Promise<AcompanhamentoEntregaCIF[]> {
    let ok: boolean = false;
    let data: AcompanhamentoEntregaCIF[];
    let error: any = undefined;
    let url: string = calls[0].rota;
    await super
      .post(url,param )
      .then((response: AxiosResponse) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<AcompanhamentoEntregaCIF[]>((resolve) => {
      resolve(data);
    });
  }
*/
  async getAll(param : AcompanhamentoCargaCIFCompleteParameters): Promise<AcompanhamentoEntregaCIF[]> {
    return super.post(calls[0].rota, param)
    .then((result) => {
      return result;
    });    
  }
}
